import { useEffect, useState } from "react";

import { ResponseVehicle } from "services/motorpoint/shortlist";
import getVehicleRecommendations from "services/vehicle-recommendations";

const useRecommendedVehicles = (stockNumber: string | number) => {
    const [recommendedVehicles, setRecommendedVehicles] = useState<ResponseVehicle[] | undefined>(
        []
    );

    useEffect(() => {
        const fetchData = async () => {
            const response = await getVehicleRecommendations({ stockNumber });
            setRecommendedVehicles(response);
        };

        fetchData();
    }, [stockNumber]);

    return recommendedVehicles;
};

export default useRecommendedVehicles;
